import React from 'react'
import Section2 from '../../ComponentsPage/Service/Section2'
import Section3 from '../../ComponentsPage/Service/Section3'
import ServiceBanner from '../../ComponentsPage/Banner/ServiceBanner'
const Service = () => {
  return (
    <div>
        <ServiceBanner/>
        <Section2/>
        {/* <Section3/> */}
    </div>
  )
}

export default Service
